import React, { useState } from 'react'
import Games from '../data/games.json'
import { Link } from 'react-router-dom';

export default function TreeDayMatches() {

    const current = new Date();
    const yesterday = `${current.getDate() - 1}/${current.getMonth() + 1}/${current.getFullYear()}`;
    const today = `${current.getDate()}/${current.getMonth() + 1}/${current.getFullYear()}`;
    const tomorrow = `${current.getDate() + 1 }/${current.getMonth() + 1}/${current.getFullYear()}`;

    const [type, setType] = useState(2)


    const navigation = [
        { name: "یاریەکانی دوێنێ", num: 1 },
        { name: "یاریەکانی ئەمڕۆ", num: 2 },
        { name: "یاریەکانی سبەی", num: 3 }

    ]

    const yesterdaygame=()=>{
        return(
             <div className='flex flex-col  w-full items-center space-y-3 '>
                            
                            <div className="md:w-full  flex flex-wrap w-full relative overflow-x-auto  rounded-lg">

        

                                {Games.map((team) => {
                                    return (
                                        team.date === yesterday ? (
                                            <>

                                                <div className='flex flex-col my-3 items-center md:items-end border-2 bg-yakam rounded-lg w-full md:w-[45%]   p-1 md:p-3 mx-auto'>
                                                    <div className='space-y-3 mx-auto text-chwaram'>

                                                        <h1 className=' text-center'>کۆمەڵەکان<br />{team.date}</h1>
                                                        <div className='flex flex-row space-x-4 mx-auto'>

                                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-1 md:text-lg text-xs space-x-1'> <img src={team.logot1} alt={team.logot1} /> <p>{team.team1}</p></div>
                                                            <div className='bg-seyam text-shasham rounded-lg flex flex-col justify-center px-4 '>{team.time}</div>
                                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-1 md:text-lg text-xs space-x-1'>  <p>{team.team2}</p><img src={team.logot2} alt={team.logot2} /></div>

                                                        </div>

                                                        <div className='text-center'>
                                                            <Link to='/peshbinikrdn' className="font-medium text-c7  hover:text-chwaram">پێشبینی بکە</Link>
                                                        </div>

                                                        

                                                    </div>
                                                </div>

                                            </>
                                        )
                                            :
                                            (
                                                null
                                            )

                                    )

                                })}
                            </div>
                        </div> 

        )
    }
    const todaygame=()=>{
        return(
             <div className='flex flex-col w-full items-center space-y-3 '>
                            
                            <div className="md:w-full w-full relative flex flex-wrap overflow-x-auto  rounded-lg">

        

                                {Games.map((team, index) => {
                                    return (
                                        team.date === today ? (
                                            <>

                                                <div className='flex flex-col my-3 items-center md:items-end border-2 bg-yakam rounded-lg w-full md:w-[45%]  p-1 md:p-3 mx-auto'>
                                                    <div className='space-y-3 mx-auto text-chwaram'>

                                                        <h1 className=' text-center'>کۆمەڵەکان<br />{team.date}</h1>
                                                        <div className='flex flex-row space-x-4 mx-auto'>

                                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-1 md:text-lg text-xs space-x-1'> <img src={team.logot1} alt={team.logot1} /> <p>{team.team1}</p></div>
                                                            <div className='bg-seyam text-shasham rounded-lg flex flex-col justify-center px-4 '>{team.time}</div>
                                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-1 md:text-lg text-xs space-x-1'>  <p>{team.team2}</p><img src={team.logot2} alt={team.logot2} /></div>

                                                        </div>

                                                        <div className='text-center'>
                                                            <Link to='/peshbinikrdn' className="font-medium text-c7  hover:text-chwaram">پێشبینی بکە</Link>
                                                        </div>

                                                        

                                                    </div>
                                                </div>

                                            </>
                                        )
                                            :
                                            (
                                                null
                                            )

                                    )

                                })}
                            </div>
                        </div> 

        )
    }
    const tomorrowgame=()=>{
        return(
             <div className='flex flex-col w-full items-center space-y-3 '>
                            
                            <div className="md:w-full w-full relative flex flex-wrap overflow-x-auto  rounded-lg">

        

                                {Games.map((team, index) => {
                                    return (
                                        team.date === tomorrow ? (
                                            <>

                                                <div className='flex flex-col my-3 items-center md:items-end border-2 bg-yakam rounded-lg w-full md:w-[45%]  p-1 md:p-3 mx-auto'>
                                                    <div className='space-y-3 mx-auto text-chwaram'>

                                                        <h1 className=' text-center'>کۆمەڵەکان<br />{team.date}</h1>
                                                        <div className='flex flex-row space-x-4 mx-auto'>

                                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-1 md:text-lg text-xs space-x-1'> <img src={team.logot1} alt={team.logot1} /> <p>{team.team1}</p></div>
                                                            <div className='bg-seyam text-shasham rounded-lg flex flex-col justify-center px-4 '>{team.time}</div>
                                                            <div className='bg-seyam text-shasham rounded-lg  flex items-center md:p-2 p-1 md:text-lg text-xs space-x-1'>  <p>{team.team2}</p><img src={team.logot2} alt={team.logot2} /></div>

                                                        </div>

                                                        <div className='text-center'>
                                                            <Link to='/peshbinikrdn' className="font-medium text-c7  hover:text-chwaram">پێشبینی بکە</Link>
                                                        </div>

                                                        

                                                    </div>
                                                </div>

                                            </>
                                        )
                                            :
                                            (
                                                null
                                            )

                                    )

                                })}
                            </div>
                        </div> 

        )
    }


    return (
        <div className='flex flex-col w-full'>

            <div className=' bg-yakam w-full '>

                <div className='flex flex-row' >
                    {navigation.map((nav) => {
                        return (
                            <>
                                <div onClick={() => { setType(nav.num) }} className='w-1/3 p-3 h-full text-xs md:text-xl cursor-pointer item-center text-center hover:bg-seyam hover:text-yakam text-chwaram'><p className=''>{nav.name}</p></div>
                            </>
                        )
                    })}
                </div>

                
            </div>

                <div>
                {type === 1 ?
                        (
                            yesterdaygame()
                        )
                        :
                        type === 2 ?
                            (
                                todaygame()
                            )
                            :
                            type === 3 ?
                                (
                                    tomorrowgame()
                                )
                                :
                                (
                                    null
                                )
                    }
                </div>

        </div>
        


    )
}
